import { render, staticRenderFns } from "./TeamsAndStatuses.vue?vue&type=template&id=21cd33d4&"
import script from "./TeamsAndStatuses.vue?vue&type=script&lang=js&"
export * from "./TeamsAndStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports